var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 29,
    rx: 4.5,
    fill: "white",
    stroke: "#9876A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 21.9045C38 24.4717 35.9095 26.5622 33.3423 26.5622H8V8.11473C8 5.5475 10.0905 3.45703 12.6577 3.45703H38V21.9045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4536 5.01562C29.6199 5.01562 28.1162 6.50095 28.1162 8.35303V11.8188H32.829C32.939 11.8188 33.0673 11.8188 33.159 11.8371C34.2226 11.8922 35.0111 12.4423 35.0111 13.3958C35.0111 14.1477 34.4793 14.7895 33.4891 14.9178V14.9545C34.571 15.0278 35.3962 15.633 35.3962 16.5682C35.3962 17.5767 34.4793 18.2369 33.269 18.2369H28.0979V25.0217H32.994C34.8277 25.0217 36.3314 23.5364 36.3314 21.6843V5.01562H31.4536Z",
    fill: "#05A551"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 17.1733H31.6737C31.7012 17.1733 31.747 17.1687 31.7929 17.1641C31.8387 17.1596 31.8846 17.155 31.9121 17.155C32.2788 17.0816 32.5906 16.7515 32.5906 16.2931C32.5906 15.853 32.2788 15.5229 31.9121 15.4313C31.8571 15.4129 31.747 15.4129 31.6737 15.4129H29.7483V17.1733Z",
    fill: "#05A551"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6737 12.8274C32.0404 12.8824 32.3522 13.1758 32.3522 13.6159C32.3522 14.056 32.0404 14.3494 31.6737 14.4044C31.6554 14.4227 31.5453 14.4227 31.4903 14.4227H29.7483V12.809H31.4903C31.5206 12.809 31.562 12.8146 31.5992 12.8196C31.6296 12.8236 31.6572 12.8274 31.6737 12.8274Z",
    fill: "#05A551"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0061 5.01562C11.1724 5.01562 9.66873 6.50096 9.66873 8.35303V16.5865C10.6039 17.045 11.5758 17.3384 12.5477 17.3384C13.703 17.3384 14.3264 16.6415 14.3264 15.688V11.8005H17.1871V15.6697C17.1871 17.1733 16.2519 18.4019 13.0795 18.4019C11.1541 18.4019 9.65039 17.9802 9.65039 17.9802V25.0034H14.5465C16.3802 25.0034 17.8839 23.5181 17.8839 21.666V5.01562H13.0061Z",
    fill: "#0A4EA1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2297 5.01562C20.396 5.01562 18.8923 6.50096 18.8923 8.35303V12.7173C19.7359 12.0022 21.2028 11.5437 23.5684 11.6538C24.8337 11.7088 26.1906 12.0572 26.1906 12.0572V13.4692C25.5121 13.1208 24.7053 12.809 23.6601 12.7357C21.863 12.6073 20.7811 13.4875 20.7811 15.0279C20.7811 16.5865 21.863 17.4667 23.6601 17.32C24.7053 17.2467 25.5121 16.9166 26.1906 16.5865V17.9985C26.1906 17.9985 24.852 18.3469 23.5684 18.4019C21.2028 18.512 19.7359 18.0535 18.8923 17.3384V25.0401H23.7884C25.6222 25.0401 27.1258 23.5547 27.1258 21.7027V5.01562H22.2297Z",
    fill: "#EE1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.fe10f77af53ae46959ea66848a70238a.svg";
export { ForwardRef as ReactComponent };